import { useRiskProfileSocialEconomicRequest } from './useRiskProfileSocialEconomicRequest'
import { useRiskProfileSocialEconomicQuery } from './useRiskProfileSocialEconomicQuery'
import type { PropertiesQueryParams } from '../types/riskProfileProperties.types'

export function useEconomicHazardData(queryParams: PropertiesQueryParams | null) {
  const request = useRiskProfileSocialEconomicRequest({
    queryParams,
    widget: 'disruptionByHazard',
  })
  const query = useRiskProfileSocialEconomicQuery(request)
  return { request, query }
}
